import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import { type CreativeScore, scoreTier } from './data/creativeScore';

export function CreativeScoreBadge({ creativeScore }: { creativeScore: CreativeScore }): ReactNode {
  const theme = useTheme();
  const color =
    creativeScore.score === null
      ? theme.palette.text.disabled
      : theme.palette.score[scoreTier(creativeScore.score)].main;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Typography sx={{ fontSize: 16, fontWeight: 800, color }}>
        {creativeScore.score === null ? '—' : Math.round(creativeScore.score)}
      </Typography>
    </Box>
  );
}
